'use strict';

$('.MUFE-products-carousel').slick({
    slidesToShow: 3,
    centerMode: false,
    arrows: false,
    swipe: true,
    infinite: false,
    initialSlide: 0,
    swipeToSlide: true,
    dots: false,
    autoplay: false,
    responsive: [{
        breakpoint: 1024,
        settings: {
            slidesToShow: 3,
            centerMode: false,
            arrows: true,
            swipe: true,
            infinite: false,
            initialSlide: 0,
            swipeToSlide: true,
            autoplay: false,
            dots: false,
        }
    },
    {
        breakpoint: 768,
        settings: {
            slidesToShow: 1.3,
            centerMode: false,
            initialSlide: 0,
            arrows: true,
            swipe: true,
            infinite: true,
            dots: false
        }
    }]
});

if ($('.AGEC-component-3').length) {
    var useMobile = $(window).outerWidth() <= 768;

    if (useMobile) {
        $('.AGEC-component-3').append('<div class="agec-wrapper-carousel"></div>');

        $('.AGEC-component-3').find('.agec-item').each(function () {
            if ($(this).find('.experience-component').length) {
                $('.agec-wrapper-carousel').append('<div class="agec-item">' + $(this).html() + '</div>');
            }
        });

        $('.agec-wrapper-carousel').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: true,
            arrows: false,
            swipe: true,
            infinite: true,
            initialSlide: 0,
            swipeToSlide: true,
            dots: false,
            autoplay: false,
        });

    }

}

const moveDotsInsideSliderEMP = (slider, destination) => {
    slider.find('.slick-dots').not('.cloned-dots').clone().appendTo(slider.find(destination))
    slider.find(destination).find('.slick-dots').addClass('cloned-dots')
};

const calculateImgHeight = (slider) => {
    var currentImgHeight = slider.find('.slick-current.slick-active img').not('.desktop-img').height();

    if (window.matchMedia("(max-width: 1200px)").matches) {
        slider.find('.slick-arrow').css('height', currentImgHeight)
    }
};

const slickGoto = (slider, index) => {
    slider.slick('slickGoTo', parseInt(index));
};

if ($('.EMP-component-3').length) {
    var EMP_Component = $('.EMP-component-3');
    var useMobile = $(window).outerWidth() <= 768;

    if (useMobile) {
        EMP_Component.prepend('<div class="EMP-wrapper-carousel"></div>');
        $('<div class="EMP-col-item-body"></div>').insertAfter('.EMP-wrapper-carousel');

        EMP_Component.find('.EMP-col-item').each(function () {
            if ($(this).find('.experience-component').length) {
                $('.EMP-wrapper-carousel').append('<div class="EMP-col-item">' + $(this).html() + '</div>');
            }
        });

        $('.EMP-wrapper-carousel').slick({
            slidesToShow: 1.3,
            slidesToScroll: 1,
            centerMode: false,
            arrows: false,
            swipe: true,
            infinite: false,
            initialSlide: 0,
            swipeToSlide: true,
            dots: false,
            autoplay: false,
        });

        var EMP_item_body = $('.EMP-col-item-body');
        var contentBody = $('.slick-current.slick-active').find('.EMP-body').html();
        EMP_item_body.append('<div class="EMP-body">' + contentBody + '</div>');

        $('.EMP-wrapper-carousel').on('afterChange', function (event, slick, currentSlide, nextSlide) {
            var selfBody = $(this).find('.slick-current.slick-active .EMP-body').html();

            EMP_item_body.empty();
            EMP_item_body.append('<div class="EMP-body">' + selfBody + '</div>');
        });
    }

}

if ($('.EMP-claim-slider').length) {
    var sliderEPMClaim = $('.EMP-claim-slider');
    var useMobile = $(window).outerWidth() <= 768;
    const isBrandLayout = sliderEPMClaim.hasClass('brand-claim-layout');

    sliderEPMClaim.find('.EMP-claim-item').each(function () {
        if ($(this).is(':empty')) {
            $(this).remove();
        }
    });

    function limitTextLengthHandler(parentSlider, parentItem) {
        var limitTextLength = 267;
        var text = $(parentSlider).find('.slick-current.slick-active .EMP-claim-body .EMP-claim-text').text();
        var len = text.length;

        if (len > limitTextLength) {
            $(parentItem).find('.EMP-claim-text').text($(parentItem).find('.EMP-claim-text').text().substr(0, limitTextLength) + '...');
        }
    }

    if (!useMobile) {
        if (!isBrandLayout) {

            sliderEPMClaim.slick({
                slidesToShow: 4,
                slidesToScroll: 1,
                centerMode: false,
                arrows: true,
                swipe: true,
                infinite: true,
                initialSlide: 0,
                swipeToSlide: true,
                dots: true,
                autoplay: false,
                adaptiveHeight: true,
                nextArrow: '<button class="next-arrow"><span class="EMP-arrow"><span class="icon-CHEVRON"></span></span></button>',
                prevArrow: '<button class="prev-arrow"><span class="EMP-arrow"><span class="icon-CHEVRON"></span></span></button>'
            });

        }
    } else {
        $('<div class="EMP-claim-item-body"></div>').insertAfter('.EMP-claim-slider');
        sliderEPMClaim.slick({
            slidesToShow: 1.3,
            slidesToScroll: 1,
            centerMode: false,
            arrows: false,
            swipe: true,
            infinite: false,
            initialSlide: 0,
            swipeToSlide: true,
            dots: false,
            autoplay: false,
        });

        var EMP_claim_body = $('.EMP-claim-item-body');
        var contentBody = $('.slick-current.slick-active').find('.EMP-claim-body').html();

        EMP_claim_body.append(contentBody);
        limitTextLengthHandler('.EMP-claim-slider', '.EMP-claim-item-body');

        sliderEPMClaim.on('afterChange', function () {
            var selfBody = $(this).find('.slick-current.slick-active .EMP-claim-body').html();

            EMP_claim_body.empty();
            EMP_claim_body.append(selfBody);
            limitTextLengthHandler(this, '.EMP-claim-item-body');
        });
    }
}

if ($('.EMP-component-4').length) {
    $('.EMP-component-4').each(function () {
        var self = $(this);
        var sliderEMP = self.find('.EMP-slide');
        var destination_EMP_items = sliderEMP.find('.text-content-2');

        sliderEMP.find('.EMP-item').each(function () {
            if ($(this).is(':empty')) {
                $(this).remove();
            }
        });

        self.find('.EMP-slide').each(function () {
            if ($(this).find('.EMP-item').length > 1) {
                $(this).slick({
                    slidesToShow: 1,
                    centerMode: false,
                    arrows: true,
                    swipe: true,
                    infinite: true,
                    initialSlide: 0,
                    swipeToSlide: true,
                    dots: true,
                    autoplay: false,
                    nextArrow: '<button class="next-arrow"><span class="EMP-arrow"><span class="icon-CHEVRON"></span></span></button>',
                    prevArrow: '<button class="prev-arrow"><span class="EMP-arrow"><span class="icon-CHEVRON"></span></span></button>'
                });
            }
        });

        moveDotsInsideSliderEMP(sliderEMP, destination_EMP_items);
        sliderEMP.on('afterChange', function (event, slick, currentSlide, nextSlide) { // eslint-disable-line no-unused-vars
            sliderEMP.find(destination_EMP_items).find('.slick-dots').remove();
            moveDotsInsideSliderEMP(sliderEMP, destination_EMP_items);
            calculateImgHeight(sliderEMP);
        });

        $(document).on('click', '.EMP-slide .cloned-dots li', function () {
            var self = $(this).index();

            slickGoto(sliderEMP, self);
        });
    });
}

if ($('.LSHOP-artist-componenet').length) {
    var useMobile = $(window).outerWidth() <= 768;

    $(document).on('click', '.lives-artist .btn-action', function () {
        var self = $(this);
        var parent = self.parents('.lives-artist');

        parent.toggleClass('active');
    });

    if (useMobile) {
        $('.LSHOP-artist-componenet').append('<div class="LSHOP-wrapper-carousel"></div>');

        $('.LSHOP-artist-componenet').find('.LSHOP-artist-item').each(function () {
            if ($(this).find('.experience-component').length) {
                $('.LSHOP-wrapper-carousel').append('<div class="LSHOP-artist-item">' + $(this).html() + '</div>');
            }
        });

        var lpArtistItem = $('.LSHOP-wrapper-carousel').find('.LSHOP-artist-item');

        if (lpArtistItem.length === 2) {
            $('.LSHOP-wrapper-carousel').slick({
                slidesToShow: 1.1,
                slidesToScroll: 1,
                centerMode: false,
                arrows: false,
                swipe: true,
                infinite: false,
                initialSlide: 0,
                swipeToSlide: true,
                dots: false,
                autoplay: false,
            });
        } else if (lpArtistItem.length > 2) {
            $('.LSHOP-wrapper-carousel').slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                centerMode: true,
                arrows: false,
                swipe: true,
                infinite: true,
                initialSlide: 0,
                swipeToSlide: true,
                dots: false,
                autoplay: false,
            });
        }
    }
}

if ($('.EMP-collectif-slider').length) {
    const sliderEMPColl = $('.EMP-collectif-slider');
    const destinationEMPColl = sliderEMPColl.find('.text-centent-collectif');

    sliderEMPColl.find('.EMP-item-cp-3').each(function () {
        if ($(this).is(':empty')) {
            $(this).remove();
        }
    });

    sliderEMPColl.slick({
        slidesToShow: 1,
        centerMode: false,
        arrows: true,
        swipe: true,
        infinite: true,
        initialSlide: 0,
        swipeToSlide: true,
        dots: true,
        autoplay: false,
        nextArrow: '<button class="next-arrow"><span class="EMP-arrow"><span class="icon-CHEVRON"></span></span></button>',
        prevArrow: '<button class="prev-arrow"><span class="EMP-arrow"><span class="icon-CHEVRON"></span></span></button>'
    });

    setTimeout(() => {
        calculateImgHeight(sliderEMPColl)
    }, 500)

    $(window).on('resize', function () {
        calculateImgHeight(sliderEMPColl)
    });

    moveDotsInsideSliderEMP(sliderEMPColl, destinationEMPColl)
    sliderEMPColl.on('afterChange', function (event, slick, currentSlide, nextSlide) {
        sliderEMPColl.find(destinationEMPColl).find('.slick-dots').remove()
        moveDotsInsideSliderEMP(sliderEMPColl, destinationEMPColl)
        calculateImgHeight(sliderEMPColl)
    });

    $(document).on('click', '.EMP-collectif-slider .cloned-dots li', function () {
        var self = $(this).index();

        slickGoto(sliderEMPColl, self);
    });
}

function moveDotsInsideSlider(slider, destination) {
    slider.find('.pd-carousel-indicators').not('.cloned-dots').clone().appendTo(slider.find(destination))
    slider.find(destination).find('.pd-carousel-indicators').addClass('cloned-dots')
}

const pride_slider = $('.PRIDE-slider');
const destination_dots = '.js-destination-dots';

pride_slider.each(function () {
    moveDotsInsideSlider($(this), destination_dots)
})

pride_slider.on('click', '.carousel-control-prev, .carousel-control-next', () => {
    $(this).closest('.PRIDE-slider').find(destination_dots).find('.pd-carousel-indicators').remove()
    moveDotsInsideSlider($(this).closest('.PRIDE-slider'), destination_dots)
});

pride_slider.each(function () {
    $(this).on('click', '.carousel-control-prev', function () {
        var currentSlider = $(this).closest('.PRIDE-slider')
        var nbOfSlids = currentSlider.data('number-of-slides')
        var activeCarouselPosition = 0
        if (currentSlider.find('.pd-carousel-indicators .active').data('position') == 0) {
            activeCarouselPosition = nbOfSlids - 1
        } else {
            activeCarouselPosition = currentSlider.find('.carousel-item.active').data('position') - 1
        }
        currentSlider.find('.pd-carousel-indicators .active').removeClass('active');
        currentSlider.find(".pd-carousel-indicators [data-position='" + activeCarouselPosition + "']").addClass('active');
    });

    $(this).on('click', '.carousel-control-next', function () {
        var currentSlider = $(this).closest('.PRIDE-slider')
        var nbOfSlids = currentSlider.data('number-of-slides')
        var activeCarouselPosition = 0
        if (currentSlider.find('.pd-carousel-indicators .active').data('position') + 1 == nbOfSlids) {
            activeCarouselPosition = 0
        } else {
            activeCarouselPosition = currentSlider.find('.carousel-item.active').data('position') + 1
        }
        currentSlider.find('.pd-carousel-indicators .active').removeClass('active');
        currentSlider.find(".pd-carousel-indicators [data-position='" + activeCarouselPosition + "']").addClass('active');
    });
});

$('img.common-image-component').hover(
    function () {
        $(this).data('title', $(this).attr('title')).removeAttr('title');
    },
    function () {
        $(this).attr('title', $(this).data('title'));
    }
);